import axios from "axios"

const FormasContactoService = {
  getFormasContactoById(id: $TSMigrationFixMe) {
    return axios.get(`/FormaContacto/${id}`)
  },
  getFormasContactoEmpresaById(id: $TSMigrationFixMe) {
    return axios.get(`/FormaContacto/empresa/${id}`)
  },

  updateFormaContacto(contacto: $TSMigrationFixMe) {
    return axios.put(`/FormaContacto/${contacto.id}`, contacto)
  },

  deleteFormaContacto(id: $TSMigrationFixMe) {
    return axios.delete(`/FormaContacto/${id}`)
  },

  insertFormaContacto(contacto: $TSMigrationFixMe) {
    return axios.post(`/FormaContacto/`, contacto)
  },
}

export default FormasContactoService
